import { render, staticRenderFns } from "./PortfolioAbout.vue?vue&type=template&id=fc099f22&scoped=true&"
import script from "./PortfolioAbout.vue?vue&type=script&lang=js&"
export * from "./PortfolioAbout.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioAbout.vue?vue&type=style&index=0&id=fc099f22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc099f22",
  null
  
)

export default component.exports